<div class="main-box">
  <div class="main-grid" [formGroup]="schoolService.schoolForm" *ngIf="schoolService.schoolForm">
    <div class="left-container">
      <div class="general-info-container">
        <h3 class="global-title">
          Basic information
        </h3>
        <table class="about-table">
          <tr>
            <td>
              <p *ngIf="nameIsNull" class="global-warning">
                School name is required
              </p>
              <p>
                Partner name
              </p>
              <input pInputText placeholder="Name" type="text" formControlName="name" class="school-name">
            </td>
            <td>
              <div>
                <p>
                  Internal name
                </p>
                <input pInputText formControlName="internalName" class="school-name">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <p>
                  Official name
                </p>
                <input pInputText formControlName="officialName" class="school-name">
              </div>
            </td>
            <td>
              <div>
                <p>
                  External name
                </p>
              </div>
              <input pInputText formControlName="externalName" class="school-name">
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <p>
                  Code
                </p>
                <input pInputText formControlName="code">
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div>
                <p>
                  Website
                </p>
                <input pInputText formControlName="siteUrl" class="url-input">
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <p>
                Programme type
              </p>
              <div class="programme-types-container">
                <div class="left-programmes">
                  <div
                    *ngFor="let programmeType of programmeTypeFormArray; let index = index"
                    class="programme-type-item">
                    <p-dropdown dataKey="id" [formControl]="programmeType | formControl" optionLabel="name"
                      placeholder="Select Programme Type" [options]="schoolService.programmeTypes" scrollHeight="420px">
                    </p-dropdown>
                    <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="removeProgrammeType(index)"
                      [disabled]="this.schoolService.selectedSchool.isDeleted"></p-button>
                  </div>
                </div>
                <div class="right-programmes">
                  <p-button (onClick)="addProgrammeType()" label="Add"
                    [disabled]="this.schoolService.selectedSchool.isDeleted"></p-button>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <p>
                Comment
              </p>
              <div class="comment-editor-container">
                <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="other-information-container">
        <h3 class="global-title">
          Other
        </h3>
        <div>
          <div class="appointment-time-default-payment-container">
            <div>
              <p>
                Appointment time (hh:mm)
              </p>
              <input pInputText formControlName="appointmentTime">
            </div>
            <div>
              <p>
                Default payment account
              </p>
              <p-dropdown [options]="bankAccounts" optionLabel="iban" formControlName="defaultBank"></p-dropdown>
            </div>
          </div>
          <div>
            <p>
              Price URL (Google Sheet)
            </p>
            <input pInputText formControlName="googleSheetUrl">
          </div>
        </div>
        <div>
          <h3 class="global-title">
            Website pages
          </h3>
          <div class="programme-information-form-header">
            <div>
              <p>
                Language
              </p>
            </div>
            <div>
              <p>
                URL
              </p>
            </div>
            <div>
              <p>
                Label (max.7)
              </p>
            </div>
          </div>
          <div *ngFor="let control of programmeInfoFormArray"
            [formGroup]="control | formGroup" class="programme-information-grid">
            <div>
              <p-dropdown [options]="schoolService.languages" optionLabel="name"
                formControlName="language"></p-dropdown>
            </div>
            <div>
              <input pInputText formControlName="lviSiteUrl">
            </div>
            <div>
              <input pInputText formControlName="label" class="programme-label-input">
            </div>
          </div>
          <div>
            <p-button label="Add" (onClick)="schoolService.pushProgrammeInformationForm()"
              [disabled]="this.schoolService.selectedSchool.isDeleted"></p-button>
          </div>
        </div>
        <div class="school-other-info-item">
          <p>
            Require student address
          </p>
          <p-checkbox [binary]="true" formControlName="requireStudentAddress"></p-checkbox>
        </div>
        <div class="school-other-info-item">
          <p>
            Require student phone number
          </p>
          <p-checkbox [binary]="true" formControlName="requireStudentPhoneNumber"></p-checkbox>
        </div>
        <div>
          <p>
            Contact Language
          </p>
          <p-dropdown [options]="schoolService.languages" optionLabel="name" formControlName="language"></p-dropdown>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="address-container">
        <h3 class="global-title">
          Contact information
        </h3>
        <table class="school-address-table">
          <tr>
            <td>
              <div>
                <p>
                  Street
                </p>
                <input pInputText formControlName="street" class="street-input">
              </div>
            </td>
            <td>
              <div>
                <p>
                  Postal code
                </p>
                <input pInputText formControlName="postalCode" class="street-input">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <p>
                  City
                </p>
                <input pInputText formControlName="city" class="street-input">
              </div>
            </td>
            <td>
              <div>
                <p>
                  Phone number
                </p>
                <input pInputText formControlName="phoneNumber" class="street-input">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <p>
                  Emergency number
                </p>
                <input pInputText formControlName="emergencyPhoneNumber" class="street-input">
              </div>
            </td>
            <td>
              <div>
                <p>
                  Country
                </p>
                <p-dropdown dataKey="id" [filter]="true" filterBy="label" formControlName="homeCountry" placeholder="Select Country"
                  [options]="schoolService.itemGroups" [group]="true" scrollHeight="420px"></p-dropdown>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span>
                Show partner address in final confirmation
              </span>
              <p-checkbox [binary]="true" formControlName="requireSchoolAddress"></p-checkbox>
            </td>
          </tr>
        </table>
      </div>
      <div class="countries-container">
        <div>
          <h3 class="global-title">
            Countries
          </h3>
          <div>
            <div class="countries-dropdown-container">
              <div *ngFor="let control of countryFormArray; let index = index" class="country-item">
                <p-dropdown dataKey="id" [filter]="true" filterBy="label" [formControl]="control | formControl"
                  placeholder="Select Country" [options]="schoolService.itemGroups" [group]="true"
                  scrollHeight="420px"></p-dropdown>
                <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="removeCountry(index)"
                  [disabled]="this.schoolService.selectedSchool.isDeleted"></p-button>
              </div>
            </div>
            <div class="right-contries">
              <p-button (onClick)="addCountry()" label="Add"
                [disabled]="this.schoolService.selectedSchool.isDeleted"></p-button>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-container">
        <app-school-contact-edit #editContact></app-school-contact-edit>
      </div>
    </div>
    <div class="comment-section">
      <p-dialog header="Modifier la publication" [modal]="true" [(visible)]="display">
        <div [formGroup]="commentUpdateForm" *ngIf="commentUpdateForm" class="comment-update-container">
          <input placeholder="Title" formControlName="title">
          <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
        </div>
        <button (click)="updateComment()">Send</button>
      </p-dialog>
      <div [formGroup]="schoolService.commentForm" *ngIf="commentForm" class="comment-form">
        <input placeholder="Title" formControlName="title">
        <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
        <button [disabled]="commentForm.invalid" (click)="postComment()">Post</button>
      </div>
    </div>
  </div>

</div>